import { PropertyMediaKind, type CatalogProperty } from 'src/api/generated';

/** Finds the first ordered property image for cards and selection menus. */
export const getPrimaryImageFileId = (
  property: CatalogProperty
): string | null => {
  const primaryImage = [...property.media]
    .filter((item) => item.kind === PropertyMediaKind.IMAGE)
    .sort((left, right) => left.position - right.position)
    .at(0);

  if (!primaryImage) {
    return null;
  }

  const fileId = primaryImage.fileId.trim();
  return fileId.length > 0 ? fileId : null;
};
